// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.deployment.browser_session.BrowserSession

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";

export interface BrowserSessionData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "BrowserSession";
    id: string;
    cwd: string | null;
    current_url: string | null;
    width: number;
    height: number;
    is_mobile: boolean;
    bitrate: number;
    framerate: number;
    is_alive: boolean;
    is_streaming: boolean;
    whep_url: string | null;
    devtools_open: boolean;
    network_log: Record<string, unknown>[];
    console_log: Record<string, unknown>[];
    css_cursor: string;
    name: string | null;
}

export class BrowserSessionStore {
    readonly _entity_class_name = "BrowserSession" as const;
    id: string;
    cwd: string | null;
    current_url: string | null;
    width: number;
    height: number;
    is_mobile: boolean;
    bitrate: number;
    framerate: number;
    is_alive: boolean;
    is_streaming: boolean;
    whep_url: string | null;
    devtools_open: boolean;
    network_log: Record<string, unknown>[];
    console_log: Record<string, unknown>[];
    css_cursor: string;
    name: string | null;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: BrowserSessionData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.id = wrapEntity(data.id, transport, [...chainPath, "id"]);
        this.cwd = wrapEntity(data.cwd, transport, [...chainPath, "cwd"]) ?? null;
        this.current_url = wrapEntity(data.current_url, transport, [...chainPath, "current_url"]) ?? null;
        this.width = wrapEntity(data.width, transport, [...chainPath, "width"]);
        this.height = wrapEntity(data.height, transport, [...chainPath, "height"]);
        this.is_mobile = wrapEntity(data.is_mobile, transport, [...chainPath, "is_mobile"]);
        this.bitrate = wrapEntity(data.bitrate, transport, [...chainPath, "bitrate"]);
        this.framerate = wrapEntity(data.framerate, transport, [...chainPath, "framerate"]);
        this.is_alive = wrapEntity(data.is_alive, transport, [...chainPath, "is_alive"]);
        this.is_streaming = wrapEntity(data.is_streaming, transport, [...chainPath, "is_streaming"]);
        this.whep_url = wrapEntity(data.whep_url, transport, [...chainPath, "whep_url"]) ?? null;
        this.devtools_open = wrapEntity(data.devtools_open, transport, [...chainPath, "devtools_open"]);
        this.network_log = wrapEntity(data.network_log, transport, [...chainPath, "network_log"]);
        this.console_log = wrapEntity(data.console_log, transport, [...chainPath, "console_log"]);
        this.css_cursor = wrapEntity(data.css_cursor, transport, [...chainPath, "css_cursor"]);
        this.name = wrapEntity(data.name, transport, [...chainPath, "name"]) ?? null;
        makeObservable(this, {
            id: observable,
            cwd: observable,
            current_url: observable,
            width: observable,
            height: observable,
            is_mobile: observable,
            bitrate: observable,
            framerate: observable,
            is_alive: observable,
            is_streaming: observable,
            whep_url: observable,
            devtools_open: observable,
            network_log: observable,
            console_log: observable,
            css_cursor: observable,
            name: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async navigate(url: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "navigate", [url], {});
    }

    async resize(width: any, height: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "resize", [width, height], {});
    }

    async set_quality(bitrate: any, framerate: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "set_quality", [bitrate, framerate], {});
    }

    async start_streaming(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "start_streaming", [], {});
    }

    async stop_streaming(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "stop_streaming", [], {});
    }

    async mouse_move(x: any, y: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "mouse_move", [x, y], {});
    }

    async mouse_button(button: any, pressed: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "mouse_button", [button, pressed], {});
    }

    async scroll(dy: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "scroll", [dy], {});
    }

    async key(keysym: any, pressed: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "key", [keysym, pressed], {});
    }

    async toggle_devtools(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "toggle_devtools", [], {});
    }

    async execute_js(expression: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "execute_js", [expression], {});
    }

    async clear_console(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "clear_console", [], {});
    }

    async clear_network_log(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "clear_network_log", [], {});
    }
}

registerEntity("BrowserSession", BrowserSessionStore);
